module.exports = __webpack_public_path__ + "img/c00_buildingtechbarbedarrows_Normal_ua.38241d78.webp";